import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MIN_THRESHOLD = 300; // n'affiche le compteur qu'à partir de ce nombre

const ConfirmedCounter = () => {
  const [count, setCount] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/rsvp/count`)
      .then((res) => {
        if (mounted) {
          setCount(res?.data?.confirmed || 0);
          setLoaded(true);
        }
      })
      .catch(() => {
        if (mounted) setLoaded(true);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loaded || count < MIN_THRESHOLD) return null;

  return (
    <div
      data-testid="confirmed-counter"
      className="inline-flex items-center gap-2 bg-orange-600/15 border border-orange-500/40 px-4 py-2 rounded-full text-sm text-orange-300"
    >
      <Users className="w-4 h-4" />
      <span>
        <span className="font-bold text-orange-200">{count}</span> warriors ont déjà confirmé
      </span>
    </div>
  );
};

export default ConfirmedCounter;
